import {
  apiPageConfigGetStateContentByApp,
  ApiPageConfigGetStateContentByAppResponse,
} from '@/api'
import { fromPairs } from 'vtils'
import { parseUrlQueryString } from '@dcb/utils'
import { RequiredDeep } from 'vtils/types'

type ResourceItem =
  RequiredDeep<ApiPageConfigGetStateContentByAppResponse>['list'][0] & {
    isStrategy: boolean
    refGoods: Record<string, string>
  }

export async function loadResourceData<
  T extends Record<
    string,
    {
      id: string
      count?: number
      transformer?: (item: ResourceItem) => ResourceItem
      fallback?: Array<Partial<ResourceItem>>
    }
  >,
>(options: T): Promise<Record<keyof T, ResourceItem[]>> {
  const currentMonth = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    10: '十',
    11: '十一',
    12: '十二',
  }[new Date().getMonth() + 1]!
  return fromPairs(
    await Promise.all(
      Object.keys(options).map(name => {
        const pageSize = options[name].count || 1000
        return apiPageConfigGetStateContentByApp(
          {
            stateId: options[name].id,
            pageIndex: 1,
            pageSize: pageSize,
          },
          {
            name: name,
          },
        ).then(res => {
          let list = res.list || []
          if (!list.length && options[name].fallback) {
            list = options[name].fallback as any
          }
          return [
            name,
            list.slice(0, pageSize).map(item => {
              const _item = {
                ...item,
                title: (item.title || '').replace(/{月}/g, currentMonth),
                isStrategy: item.resType === '07',
                refGoods: parseUrlQueryString(
                  (item.targetUrl || '').split('?')[1],
                ),
                monthSales: (item.remarkMap as any)?.M_Sales || 0,
                storeAddress: (item.remarkMap as any)?.S_Address || '',
                storeTags:
                  (item.remarkMap as any)?.S_Label?.replace(/，/g, ',').split(
                    ',',
                  ) || [],
                discountTags:
                  (item.remarkMap as any)?.D_Label?.replace(/，/g, ',').split(
                    ',',
                  ) || [],
              }
              return options[name].transformer
                ? options[name].transformer!(_item as any)
                : _item
            }),
          ]
        })
      }),
    ),
  ) as any
}
